/**
 * DEV-101: хранилище токенов osago-accounts.
 *
 * Access живёт ТОЛЬКО в памяти вкладки: в localStorage его класть нельзя, оттуда его
 * забирает любой XSS, а срок жизни у него сутки. Refresh переживает перезагрузку и
 * потому лежит в localStorage - это осознанный размен: без него человек разлогинивается
 * на каждый F5, а одноразовость и детект повторного использования на стороне сервиса
 * ограничивают ущерб от кражи.
 *
 * Пока не завершён переход, рядом продолжает работать старая сессия (clientSessionId):
 * нет токена - транспорт ничего не добавляет, и всё идёт прежним путём.
 */
const REFRESH_KEY = 'osago.auth.refresh';

let accessToken: string | null = null;

/** localStorage может быть недоступен: приватное окно, заблокированные куки, iframe. */
function safeRead(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeWrite(key: string, value: string | null): void {
  try {
    if (value === null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
  } catch {
    // без персиста работаем в пределах вкладки, это не повод падать
  }
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function getRefreshToken(): string | null {
  return safeRead(REFRESH_KEY);
}

export function setTokens(access: string | null, refresh?: string | null): void {
  accessToken = access;
  if (refresh !== undefined) safeWrite(REFRESH_KEY, refresh);
}

export function clearTokens(): void {
  accessToken = null;
  safeWrite(REFRESH_KEY, null);
}

/** Есть чем авторизоваться прямо сейчас или чем восстановиться после перезагрузки. */
export function hasSession(): boolean {
  return Boolean(accessToken || getRefreshToken());
}
